import { usePathname } from 'next/navigation'

import { Button } from '~/components/component-library'

export const SidebarSection = ({
  title,
  items,
  size = 'small',
}: SidebarSectionProps) => {
  const pathname = usePathname()
  return (
    <div className="flex w-full flex-col gap-0.5">
      {title && (
        <label className="mb-1 px-2.5 pt-1 text-sm font-normal text-secondary">
          {title}
        </label>
      )}
      {items.map((page) => {
        const isActive = !!page.href && pathname.startsWith(page.href)
        return (
          <Button
            key={page.href}
            href={{ path: page.href }}
            variant="nav"
            isSelected={isActive}
            aria-current={isActive ? 'page' : undefined}
            alignLeft
            fullWidth
            size={size}
            prefix={page.prefix}
          >
            {typeof page.title === 'string' ? (
              <span className="truncate">{page.title}</span>
            ) : (
              page.title
            )}
          </Button>
        )
      })}
    </div>
  )
}

type SidebarSectionProps = {
  title?: string
  items: SidebarItem[]
  size?: 'small' | 'base'
}

type SidebarItem = {
  prefix?: React.ReactElement
  title: React.ReactNode
  href: string
}
